import { useEffect, useRef } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { AgentDot } from '../../../AgentDot';
import { BriefMark } from '../../MaestroBrief/BriefMark';
import { Button, Card, ScrollArea, Typography } from '../../ui';
import { useTranslation } from '../../../../lib/i18n';
import type { WorldMeetingView } from '../../../../lib/home-map/world-meeting';
import type { WorldAgent } from '../../../../lib/home-map/living-world';
import styles from './WorldMeetingBrief.module.css';

export function WorldMeetingBrief({ meeting, agents, maestroName, compact, onOpen }: {
  meeting: WorldMeetingView; agents: WorldAgent[]; maestroName: string; compact?: boolean; onOpen: () => void;
}) {
  const { t } = useTranslation();
  const scroll = useRef<HTMLElement>(null);
  const latest = meeting.turns.at(-1);
  useEffect(() => { if (scroll.current) scroll.current.scrollTop = scroll.current.scrollHeight; }, [latest?.id]);
  return <Card size="sm" className={`${styles.card} ${compact ? styles.compact : ''}`}>
    <div className={styles.header}><BriefMark size={20} /><Typography variant="p2">{t('home.map.brief')}</Typography>
      <span className={styles.attendees}>{meeting.agentIds.slice(0, 5).map(id => <AgentDot key={id} id={id} size={18} />)}</span>
    </div>
    {!compact && meeting.title && <Typography variant="p3" color="secondary">{meeting.title}</Typography>}
    <ScrollArea ref={scroll} className={styles.turns}>
      {(compact ? meeting.turns.slice(-1) : meeting.turns).map(turn => <div key={turn.id} className={styles.turn} data-speaking={turn.id === latest?.id}>
        <div className={styles.speaker}>{turn.agentId ? <AgentDot id={turn.agentId} size={16} /> : <BriefMark size={16} />}
          <strong>{turn.agentId ? agents.find(agent => agent.id === turn.agentId)?.name || turn.agentName || t('home.map.agent') : maestroName}</strong></div>
        <p dir="auto">{turn.text}</p>
      </div>)}
      {!meeting.turns.length && <Typography variant="p3" color="secondary">{t('brief.inProgress')}</Typography>}
    </ScrollArea>
    <Button size="small" variant="text" endIcon={<ArrowUpRight size={14} aria-hidden />} onClick={onOpen}>{t('home.map.readMeeting')}</Button>
  </Card>;
}
